import React, { useState } from "react";
import { Container, Legend, TextContent } from "./styles";
import { SectionTitle } from "App/styles";
import { InputField } from "basics";
import { SecondaryButton } from "basics/buttons";
import urlParser from "js-video-url-parser";

export default function VideoPlayer({
  title,
  id,
  register,
  error,
  value = "",
  readOnly,
}) {
  const [validUrl, setValidUrl] = useState(false);

  const [videoLink, setVideoLink] = useState(value);

  const HandleYoutubeLink = (field, value) => {
    setVideoLink(value);

    var videoData = urlParser.parse(value);

    if (videoData) {
      setValidUrl(true);
    }
  };

  return (
    <Container>
      {title && <SectionTitle>{title}</SectionTitle>}
      {!readOnly && (
        <Legend>
          El video tiene que estar subido a una plataforma online (YouTube,
          Vimeo) para que podamos cargarlo en la postulación.
        </Legend>
      )}
      <TextContent>
        <InputField
          label="Link del video"
          type={readOnly ? "link" : "text"}
          value={value}
          id={id}
          register={register}
          error={error}
          readOnly={readOnly}
          onChange={HandleYoutubeLink}
          width="100%"
        />
        {!readOnly && (
          <SecondaryButton
            as="a"
            target="_blank"
            rel="noopener noreferrer"
            href={videoLink}
            disabled={!validUrl}
          >
            Verificar
          </SecondaryButton>
        )}
      </TextContent>
    </Container>
  );
}
